export type ProfileKind = 'trabalhador' | 'restaurante';
export async function ensureProfile(entity: any, user: {userId: string; userName?: string}, type: ProfileKind, referredBy = '') {
  if (!user?.userId || !['trabalhador', 'restaurante'].includes(type)) throw new Error('Selecione o tipo de cadastro.');
  const { list } = await entity.list({ filter: { userId: user.userId }, limit: 2 });
  if (list?.length > 1) throw new Error('Há perfis duplicados. Solicite a revisão do seu cadastro.');
  if (list?.length) {
    if (list[0].userId !== user.userId) throw new Error('Perfil não autorizado.');
    if (['trabalhador', 'restaurante'].includes(list[0].profileType)) return list[0];
    // Recupera perfil incompleto, sem trocar o tipo de um cadastro existente.
    await entity.update(list[0]._id, { profileType: type, nome: list[0].nome || user.userName || '', updatedAt: new Date().toISOString() });
    return {...list[0], profileType: type};
  }
  const now = new Date().toISOString();
  const bytes = crypto.getRandomValues(new Uint8Array(12));
  const referralCode = 'BBQ' + Array.from(bytes, v => v.toString(16).padStart(2, '0')).join('').toUpperCase();
  // É uma indicação declarada, não uma comissão: validação financeira fica no servidor.
  return entity.create({ userId: user.userId, nome: user.userName || '', profileType: type,
    referralCode, referredBy: /^[A-Z0-9]{4,40}$/.test(referredBy) ? referredBy : '',
    creator: user.userId, createdAt: now, updatedAt: now });
}
